var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 206 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8314 85.5V171H0V80.6831C0 31.912 34.1337 0.602127 86.8314 0V40.3416C59.8837 42.75 47.3081 54.7923 47.3081 78.2746V85.5H86.8314ZM206 85.5V171H119.169V80.6831C119.169 31.912 153.302 0.602127 206 0V40.3416C179.052 42.75 166.477 54.7923 166.477 78.2746V85.5H206Z",
    fill: "currentColor"
  })));
};
export default SvgQuote;